import React, { useContext, useState } from 'react';
import Modal from 'modules/common/components/Modal';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import _ from 'lodash';
import { ModalContext } from 'App';
import * as actions from '../action';
import PropertyLocation from '../../PropertyLocation';
import Information from '../../Information';
import LandPropertyAssessment from '../../land-property-assessment/container/LandPropertyAssessmentContainer';
import LandSupersededAssessment from '../../land-superseded-assessment/container/LandSupersededAssessmentContainer';
import LandAppraisalContainer from '../../land-appraisal/container/LandAppraisalContainer';
import LandTransactionsContainer from '../../land-transactions/container/LandTransactionsContainer';

function ViewHistoryModal({ dataInfo }) {
  const data = dataInfo.attributes.rptax_land_application_id.toString() || '';
  const setModal = useContext(ModalContext);
  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const [activeTab, setActiveTab] = useState(1);
  const [formData, setFormData] = useState({
    scroll: 0,
  });
  const scrollref = React.createRef();

  const handleActivePage = (index) => () => {
    setActiveTab(index);
  };

  const scrollToLeft = (e) => {
    e.preventDefault();
    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const val = formData.scroll - slide < 0 ? 0 : formData.scroll - slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  const scrollToRight = (e) => {
    e.preventDefault();

    const width = scrollref.current.scrollWidth;
    const slide = width / 15;
    const calculatedWidth = width - slide;
    const val =
      formData.scroll + slide > calculatedWidth
        ? calculatedWidth
        : formData.scroll + slide;
    scrollref.current.scrollLeft = val;
    setFormData({
      scroll: val,
      totalwidth: width,
      rightdistance:
        scrollref.current.offsetWidth + scrollref.current.scrollLeft,
    });
  };

  return (
    <Modal.Body>
      <div
        className="card-content-listing pt-0"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          // padding: "10px",
          marginBottom: '20px',
        }}
      >
        <div className="mb-3">
          {!_.isEmpty(dataInfo) ? (
            <>
              <div className="page-submenu d-flex justify-content-between align-content-center">
                <button
                  type="button"
                  className="tab-arrow left"
                  onClick={scrollToLeft}
                >
                  <div
                    style={{ cursor: 'pointer' }}
                    className={`fa fa-caret-left ${
                      +formData.scroll === 0 ? 'd-none' : ''
                    }`}
                  />
                </button>
                <ul
                  className="tab-list tab-scroll no-border scroll"
                  ref={scrollref}
                >
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 1 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(1)}
                    >
                      Property Location
                    </button>
                  </li>
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 2 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(2)}
                    >
                      Information
                    </button>
                  </li>
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 3 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(3)}
                    >
                      Land Appraisal
                    </button>
                  </li>
                  {/* <li className="tab-item">
                    <button type="button" className={`btn-blank py-2 px-3 ${activeTab === 4 ? 'active' : ''}`} onClick={handleActivePage(4)}>
                      Market Value
                    </button>
                  </li> */}
                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 4 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(4)}
                    >
                      Property Assessment
                    </button>
                  </li>

                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 5 ? 'active' : ''
                      }`}
                      onClick={handleActivePage(5)}
                    >
                      Superseded Assessment
                    </button>
                  </li>

                  <li className="tab-item">
                    <button
                      type="button"
                      className={`btn-blank py-2 px-3 ${
                        activeTab === 6 ? 'active ' : ''
                      }`}
                      onClick={handleActivePage(6)}
                    >
                      Transactions
                    </button>
                  </li>
                </ul>
                <button
                  type="button"
                  className="tab-arrow right"
                  onClick={scrollToRight}
                >
                  <div
                    style={{ cursor: 'pointer' }}
                    className={`fa fa-caret-right ${
                      +formData.totalwidth === +formData.rightdistance
                        ? 'd-none'
                        : ''
                    }`}
                  />
                </button>
              </div>
              <div className="tabs-details-modal">
                {activeTab === 1 && <PropertyLocation data={dataInfo} />}
                {activeTab === 2 && (
                  <Information data={dataInfo} type="history" />
                )}
                {activeTab === 3 && (
                  <LandAppraisalContainer
                    applicationInfo={dataInfo}
                    type="history"
                  />
                )}
                {activeTab === 4 && (
                  <LandPropertyAssessment
                    applicationId={data}
                    historyApplicationId={dataInfo.id}
                    type="history"
                  />
                )}
                {activeTab === 5 && (
                  <LandSupersededAssessment
                    applicationId={data}
                    historyApplicationId={dataInfo.id}
                    type="history"
                  />
                )}
                {activeTab === 6 && (
                  <LandTransactionsContainer
                    applicationId={data}
                    historyApplicationId={dataInfo.id}
                    type="history"
                  />
                )}
              </div>
            </>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0">No Item Found</p>
              </div>
            </div>
          )}
        </div>
        <div className="col-12 d-flex justify-content-center">
          <button
            type="button"
            onClick={closeModal}
            className="btn button-close "
          >
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

ViewHistoryModal.propTypes = {
  dataInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => {};

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ViewHistoryModal);
